import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchStatistics(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/dashboard-statistics', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

  },
}
